"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This method takes in a currency code and returns a "default" locale.
 * This is not deterministic and should only be relied on to get
 * the currency symbol of a given currency, ie "$" or "¥".
 *
 * @param currencyCode
 */
exports.getDefaultLocaleForCurrencySymbol = function (currencyCode) {
    switch (currencyCode.toUpperCase()) {
        case 'AED':
            return 'ar-AE'; // UAE
        case 'AFN':
            return 'ps-AF'; // Afghanistan
        case 'ALL':
            return 'sq-AL'; // Albania
        case 'AMD':
            return 'hy-AM'; // Armenia
        case 'AOA':
            return 'pt-AO'; // Angola
        case 'ARS':
            return 'es-AR'; // Argentina
        case 'AUD':
            return 'en-AU'; // Australia
        case 'AZN':
            return 'az-AZ'; // Azerbaijan
        case 'BAM':
            return 'bs-BA'; // Bosnia
        case 'BBD':
            return 'en-BB'; // Barbados
        case 'BDT':
            return 'bn-BD'; // Bengaldesh
        case 'BGN':
            return 'bg-BG'; // Bulgaria
        case 'BHD':
            return 'ar-BH'; // Bahrain
        case 'BIF':
            return 'en-BI'; // Burundi
        case 'BMD':
            return 'en-BM'; // Bermuda
        case 'BND':
            return 'ms-BN'; // Brunei
        case 'BOB':
            return 'es-BO'; // Bolivia
        case 'BRL':
            return 'pt-BR'; // Brazil
        case 'BSD':
            return 'en-BS'; // Bahamas
        case 'BWP':
            return 'en-BW'; // Botswana
        case 'BYR':
            return 'be-BY'; // Belarus
        case 'BZD':
            return 'en-BZ'; // Belize
        case 'CAD':
            return 'en-CA'; // Canada
        case 'CDF':
            return 'ln-CD'; // Congo
        case 'CHF':
            return 'en-CH'; // Switzerland
        case 'CLP':
            return 'es-CL'; // Chile
        case 'CNY':
            return 'zh-CN'; // China
        case 'COP':
            return 'es-CO'; // Colombia
        case 'CRC':
            return 'es-CR'; // Costa Rica
        case 'CUP':
            return 'es-CU'; // Cuba
        case 'CVE':
            return 'kea-CV'; // Cape Verde
        case 'CZK':
            return 'cs-CZ'; // Czech
        case 'DJF':
            return 'so-DJ'; // Djibouti
        case 'DKK':
            return 'da-DK'; // Denmark
        case 'DOP':
            return 'es-DO'; // Dominican Republic
        case 'DZD':
            return 'ar-DZ'; // Algeria
        case 'ECS':
            return 'es-EC'; // Ecuador
        case 'EEK':
            return 'et-EE'; // Estonia
        case 'EGP':
            return 'ar-EG'; // Egypt
        case 'ETB':
            return 'aa-ET'; // Ethiopia
        case 'EUR':
            return 'de-DE'; // Germany
        case 'FJD':
            return 'en-FJ'; // Fiji
        case 'FKP':
            return 'en-FK'; // Falkan Islands
        case 'GBP':
            return 'en-GB'; // Great Britan
        case 'GEL':
            return 'ka-GE'; // Georgia (the country)
        case 'GGP':
            return 'en-GG'; // Guernsey
        case 'GHS':
            return 'ak-GH'; // Ghana
        case 'GIP':
            return 'en-GI'; // Gibraltar
        case 'GMD':
            return 'en-GM'; // Gambia
        case 'GNF':
            return 'kpe-GN'; // Guinea
        case 'GTQ':
            return 'es-GT'; // Guatemala
        case 'GYD':
            return 'en-GY'; // Guyana
        case 'HKD':
            return 'zh-HK'; // Hong Kong
        case 'HNL':
            return 'es-HN'; // Honduras
        case 'HRK':
            return 'hr-HR'; // Croatia
        case 'HTG':
            return 'ht-HT'; // Haiti
        case 'HUF':
            return 'hu-HU'; // Hungary
        case 'IDR':
            return 'en-ID'; // Indonesia
        case 'ILS':
            return 'he-IL'; // Isreal
        case 'INR':
            return 'hi-IN'; // India
        case 'IQD':
            return 'ku-IQ'; // Iraq
        case 'IRR':
            return 'fa-IR'; // Iran
        case 'ISK':
            return 'is-IS'; // Iceland
        case 'JMD':
            return 'en-JM'; // Jamaica
        case 'JOD':
            return 'ar-JO'; // Jordan
        case 'JPY':
            return 'jp-JP'; // Japan
        case 'KES':
            return 'sw-KE'; // Kenya
        case 'KGS':
            return 'ky-KG'; // Kyrgystan
        case 'KHR':
            return 'km-KH'; // Cambodia
        case 'KMF':
            return 'fr-KM'; // Comoros
        case 'KPW':
            return 'ko-KP'; // North Korea
        case 'KRW':
            return 'kr-KR'; // South Korea
        case 'KWD':
            return 'ar-KW'; // Kuwait
        case 'KYD':
            return 'en-KY'; // Cayman Islands
        case 'KZT':
            return 'kk-KZ'; // Kazahkstan
        case 'LAK':
            return 'lo-LA'; // Laos
        case 'LBP':
            return 'ar-LB'; // Lebanon
        case 'LKR':
            return 'si-LK'; // Sri Lanka
        case 'LRD':
            return 'en-LR'; // Liberia
        case 'LSL':
            return 'st-LS'; // Lesotho
        case 'LTL':
            return 'lt-LT'; // Lithuania
        case 'LVL':
            return 'lv-LV'; // Latvia
        case 'LYD':
            return 'ar-LY'; // Libya
        case 'MAD':
            return 'ar-MA'; // Morroco
        case 'MDL':
            return 'mo-MD'; // Moldova
        case 'MGA':
            return 'mg-MG'; // Madagascar
        case 'MKD':
            return 'mk-MK'; // Macedonia
        case 'MMK':
            return 'my-MM'; // Myanmar
        case 'MNT':
            return 'mn-MN'; // Mongolia
        case 'MOP':
            return 'zh-MO'; // Macau
        case 'MRO':
            return 'fr-MR'; // Mauritania
        case 'MTL':
            return 'en-MT'; // Malta
        case 'MUR':
            return 'mfe-MU'; // Marutius
        case 'MVR':
            return 'dv-MV'; // Maldives
        case 'MWK':
            return 'en-MW'; // Malawi
        case 'MXN':
            return 'es-MX'; // Mesico
        case 'MYR':
            return 'ms-MY'; // Malaysia
        case 'MZN':
            return 'pt-MZ'; // Mozambique
        case 'NAD':
            return 'af-NA'; // Namibia
        case 'NGN':
            return 'cch-NG'; // Nigeria
        case 'NIO':
            return 'es-NI'; // Nicaragua
        case 'NOK':
            return 'nb-NO'; // Norway
        case 'NPR':
            return 'ne-NP'; // Nepal
        case 'NZD':
            return 'en-NZ'; // New Zealand
        case 'OMR':
            return 'ar-OM'; // Oman
        case 'PAB':
            return 'es-PA'; // Panama
        case 'PEN':
            return 'es-PE'; // Peru
        case 'PGK':
            return 'en-PG'; // Papua New Guinea
        case 'PHP':
            return 'fil-PH'; // Phillipines
        case 'PKR':
            return 'pa-PK'; // Pakistan
        case 'PLN':
            return 'pl-PL'; // Poland
        case 'PYG':
            return 'es-PY'; // Paraguay
        case 'QAR':
            return 'ar-QA'; // Qatar
        case 'RON':
            return 'ro-RO'; // Romania
        case 'RSD':
            return 'sr-RS'; // Serbia
        case 'RUB':
            return 'ru-RU'; // Russia
        case 'RWF':
            return 'rw-RW'; // Rwanda
        case 'SAR':
            return 'ar-SA'; // Saudia Arabia
        case 'SBD':
            return 'en-SB'; // Solomon Island
        case 'SCR':
            return 'en-SC'; // Seychelles
        case 'SDG':
            return 'ar-SD'; // Sudan
        case 'SEK':
            return 'sv-SE'; // Sweden
        case 'SGD':
            return 'zh-SG'; // Singapore
        case 'SKK':
            return 'sk-SK'; // Slovakia
        case 'SLL':
            return 'sl-SL'; // Slovenia
        case 'SOS':
            return 'so-SO'; // Somalia
        case 'SRD':
            return 'nl-SR'; // Suriname
        case 'STD':
            return 'pt-ST'; // São Tomé & Príncipe
        case 'SVC':
            return 'es-SV'; // El Salvador
        case 'SYP':
            return 'syr-SY'; // Syria
        case 'SZL':
            return 'ss-SZ'; // Swaziland
        case 'THB':
            return 'th-TH'; // Thailand
        case 'TJS':
            return 'tg-TJ'; // Tajikistan
        case 'TMT':
            return 'tk-TM'; // Turkemnistan
        case 'TND':
            return 'ar-TN'; // Tunisia
        case 'TOP':
            return 'tog-TO'; // Tongo
        case 'TRY':
            return 'tr-TR'; // Turkey
        case 'TTD':
            return 'en-TT'; // Trinidad and Tobago
        case 'TWD':
            return 'zh-TW'; // Taiwan
        case 'TZS':
            return 'sw-TZ'; // Swahili
        case 'UAH':
            return 'ru-UA'; // Ukraine
        case 'UGX':
            return 'lg-UG'; // Uganda
        case 'USD':
            return 'en-US'; // USA
        case 'UYU':
            return 'es-UY'; // Uruguay
        case 'UZS':
            return 'uz-UZ'; // Uzbekistan
        case 'VEF':
            return 'es-VE'; // Venezuela
        case 'VND':
            return 'vi-VN'; // Vietnam
        case 'VUV':
            return 'en-VU'; // Vanuatu
        case 'XAF':
            return 'fr-CM'; // Cameroon
        case 'XCD':
            return 'en-VC'; // St. Vincent and Grenadines
        case 'XOF':
            return 'ee-TG'; // Togo
        case 'XPF':
            return 'fr-WF'; // Western Sahara
        case 'YER':
            return 'ar-YE'; // Yemen
        case 'ZAR':
            return 'af-ZA'; // South Africa
        case 'ZMK':
            return 'en-ZM'; // Zambia
        case 'ZWD':
            return 'en-ZW'; // Zimbambwe
        default:
            return 'en-US';
    }
};
